import { useCallback, useEffect, useState } from 'react'

import useEmblaCarousel from 'embla-carousel-react'
import type { UseEmblaCarouselType } from 'embla-carousel-react'

type UseRecipeCarouselNavReturn = {
  emblaRef: UseEmblaCarouselType[0]
  prevBtnDisabled: boolean
  nextBtnDisabled: boolean
  onPrevButtonClick: () => void
  onNextButtonClick: () => void
}

export const useRecipeCarouselNav = (): UseRecipeCarouselNavReturn => {
  const [emblaRef, emblaApi] = useEmblaCarousel({ loop: false, slidesToScroll: 'auto' })
  const [prevBtnDisabled, setPrevBtnDisabled] = useState(true)
  const [nextBtnDisabled, setNextBtnDisabled] = useState(true)

  const onPrevButtonClick = useCallback(() => {
    emblaApi?.scrollPrev()
  }, [emblaApi])

  const onNextButtonClick = useCallback(() => {
    emblaApi?.scrollNext()
  }, [emblaApi])

  const onSelect = useCallback((api: UseEmblaCarouselType[1]) => {
    if (!api) {
      setPrevBtnDisabled(true)
      setNextBtnDisabled(true)
      return
    }
    setPrevBtnDisabled(!api.canScrollPrev())
    setNextBtnDisabled(!api.canScrollNext())
  }, [])

  useEffect(() => {
    if (!emblaApi) return

    onSelect(emblaApi)
    emblaApi.on('reInit', onSelect).on('select', onSelect).on('settle', onSelect)

    return () => {
      emblaApi.off('reInit', onSelect)
      emblaApi.off('select', onSelect)
      emblaApi.off('settle', onSelect)
    }
  }, [emblaApi, onSelect])

  return { emblaRef, prevBtnDisabled, nextBtnDisabled, onPrevButtonClick, onNextButtonClick }
}
